module.exports = __webpack_public_path__ + "static/media/icon_calculator.2044f354.svg";